import { render } from "./EditMarketPlaceProduct.vue?vue&type=template&id=f0afb5b2"
import script from "./EditMarketPlaceProduct.vue?vue&type=script&lang=js"
export * from "./EditMarketPlaceProduct.vue?vue&type=script&lang=js"

import "./EditMarketPlaceProduct.vue?vue&type=style&index=0&id=f0afb5b2&lang=css"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/price-managment/modals/EditMarketPlaceProduct.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f0afb5b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f0afb5b2', __exports__)) {
    console.log('reload')
    api.reload('f0afb5b2', __exports__)
  }
  
  module.hot.accept("./EditMarketPlaceProduct.vue?vue&type=template&id=f0afb5b2", () => {
    console.log('re-render')
    api.rerender('f0afb5b2', render)
  })

}


export default __exports__